module.exports = __webpack_public_path__ + "img/2025-12-20f_1.239b9e38.jpg";